import { render } from "./ContentTranslationModal.vue?vue&type=template&id=0fd6cdc0"
import script from "./ContentTranslationModal.vue?vue&type=script&lang=js"
export * from "./ContentTranslationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__